/**
 * Decode Cognito ID token payload and detect crew-api ``lumina-admins`` group membership.
 */
const LUMINA_ADMIN_GROUP = 'lumina-admins';

function parseJwtPayload(idToken: string): Record<string, unknown> | null {
  try {
    const parts = idToken.split('.');
    if (parts.length < 2) return null;
    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = payload.length % 4;
    if (pad) payload += '='.repeat(4 - pad);
    const json = atob(payload);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function isLuminaAdmin(idToken: string | null | undefined): boolean {
  if (!idToken) return false;
  const payload = parseJwtPayload(idToken);
  if (!payload) return false;
  const groups = payload['cognito:groups'];
  if (Array.isArray(groups)) {
    return groups.includes(LUMINA_ADMIN_GROUP);
  }
  if (typeof groups === 'string') {
    return groups
      .split(',')
      .map((s) => s.trim())
      .includes(LUMINA_ADMIN_GROUP);
  }
  return false;
}
